<section class="list-view">
    @if (!isActive() && currentSurveys().length === 0) {
    <p class="md-text uscb-padding-T-0 uscb-padding-L-0">No completed surveys</p>
    }
    @if (isActive()) {
    <div class="uscb-layout-row" [class]="{'uscb-layout-align-flex-end':(currentSurveys().length > 0)}">
        <button type="button" class="uscb-primary-button uscb-margin-T-8" (click)="addSurvey()" (keyup.enter)="addSurvey()" tabindex="0">
            <i class="fa fa-plus-circle"></i> &nbsp; ADD AUTHENTICATION CODE
        </button>
    </div>
    }
    @if (currentSurveys().length !== 0) {
    <div class="uscb-layout-column" role="table">
        <div class="surveys-list fx-desktop-only" role="rowgroup">
            <div class="s-list-hd uscb-layout-row uscb-flex-row-100" role="row" tabindex="0">
                <h2 class="md-subhead ecorr-padding-LFT-sm uscb-flex-row-20" (click)="reorderSurveys('displayName')" (keyup.enter)="reorderSurveys('displayName')" role="columnheader" id="survey-list-header-name" [attr.aria-sort]="ariaSort('displayName')" tabindex="0">SURVEY NAME
                    <i class="fa" [ngClass]="fasClass('displayName')"></i>
                </h2>
                <h2 class="md-subhead ecorr-padding-LFT-sm uscb-flex-row-15" (click)="reorderSurveys('currentDueDate')" (keyup.enter)="reorderSurveys('currentDueDate')" role="columnheader" id="survey-list-header-duedate" [attr.aria-sort]="ariaSort('currentDueDate')" tabindex="0">
                    DUE
                    <i class="fa" [ngClass]="fasClass('currentDueDate')"></i>
                </h2>
                <h2 class="md-subhead ecorr-padding-LFT-sm uscb-flex-row-15" (click)="reorderSurveys('organizationName')" (keyup.enter)="reorderSurveys('organizationName')" role="columnheader" id="survey-list-header-orgname" [attr.aria-sort]="ariaSort('organizationName')" tabindex="0">NAME
                    <i class="fa" [ngClass]="fasClass('organizationName')"></i>
                </h2>
                <h2 class="md-subhead ecorr-padding-LFT-sm uscb-flex-row-10" (click)="reorderSurveys('brOrganizationId')" (keyup.enter)="reorderSurveys('brOrganizationId')" role="columnheader" id="survey-list-header-orgid" [attr.aria-sort]="ariaSort('brOrganizationId')" tabindex="0">ID
                    <i class="fa" [ngClass]="fasClass('brOrganizationId')"></i>
                </h2>
                <h2 class="md-subhead ecorr-padding-LFT-sm uscb-flex-row-20" (click)="reorderSurveys('accountManager')" (keyup.enter)="reorderSurveys('accountManager')" role="columnheader" id="survey-list-header-accmgr" [attr.aria-sort]="ariaSort('accountManager')" tabindex="0">ACCT MGR
                    <i class="fa fa-info-circle uscb-cursor-pointer-hover" [matTooltip]="acctMgrTooltipHtml | decodeXml"
                        matTooltipClass="tooltip">
                    </i>&nbsp;
                    <i class="fa" [ngClass]="fasClass('accountManager')"></i>
                </h2>
                <div class="uscb-flex" role="columnheader" id="survey-list-header-options" aria-label="Survey Options"></div>
            </div>
        </div>
        <mat-list class="uscb-flex-row-100 uscb-padding-0" role="rowgroup">
            @for (survey of currentSurveys(); track survey; let i = $index) {
            <app-list-view-instance [survey]="survey" [active]="isActive()">
            </app-list-view-instance>
            }
        </mat-list>
        <div class="uscb-margin-B-50 fx-mobile-only"></div>
    </div>
    }
</section>
